import { useCallback, useEffect, useState } from 'react';

export const useAudio = (src?: string) => {
    const [audio, setAudio] = useState<HTMLAudioElement>();
    const [duration, setDuration] = useState<number | undefined>(undefined);
    const [playing, setPlaying] = useState(false);

    const toggle = () => setPlaying(!playing);

    const stop = useCallback(() => {
        setPlaying(false);
    }, []);

    useEffect(() => {
        setAudio(new Audio(src));
    }, [src]);

    useEffect(() => {
        if (!audio) return;

        // play
        if (playing) {
            audio.play();
        }
        // stop
        else {
            audio.pause();
            audio.currentTime = 0;
        }

        return () => {
            //stop the audio when its unmounted
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        };
    }, [audio, playing]);

    useEffect(() => {
        if (!audio) return;

        audio.onloadedmetadata = () => {
            setDuration(audio.duration);
        };
    }, [audio]);

    useEffect(() => {
        if (!audio) return;

        audio.addEventListener('ended', () => {
            setPlaying(false);
            audio.currentTime = 0;
        });
        return () => {
            audio.removeEventListener('ended', () => {
                setPlaying(false);
                audio.currentTime = 0;
            });
        };
    }, [audio]);

    return { playing, duration, toggle, stop };
};
